import { readCustomFieldTypes } from './read'

export const customFieldTypes = {
  readCollection: readCustomFieldTypes,
}
